import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DatesUtilsService {
	getTodayISO(period) {
		const today = new Date();
		if (period === 'start') {
			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);
			return today;
		} else if (period === 'end') {
			today.setHours(24);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);
			return today.toISOString();
		}
	}

	getOldDateISO(period, diff) {
		const today = new Date();
		if (period === 'start') {
			today.setDate(today.getDate() - diff);
			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);
			return today.toISOString();
		} else if (period === 'end') {
			today.setDate(today.getDate() - diff);
			today.setHours(24);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);
			return today.toISOString();
		}
	}

	getFutureDateISO(period, diff) {
		const today = new Date();
		if (period === 'start') {
			today.setDate(today.getDate() + diff);
			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);
			return today.toISOString();
		} else if (period === 'end') {
			today.setDate(today.getDate() + diff);
			today.setHours(24);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0);
			return today.toISOString();
		}
	}
}
